import { render } from "./TaskModal.vue?vue&type=template&id=37f3a2dc"
import script from "./TaskModal.vue?vue&type=script&lang=js"
export * from "./TaskModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__